


































































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop({ type: [Number, String], default: 430 }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 238 }) readonly height!:
    | number
    | string;

  @Prop({ type: String, default: 'Confirm' }) readonly title!: string;
  @Prop({ type: String, default: '' }) readonly text!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: '确定' }) readonly confirmText!: string;
  @Prop({ type: Boolean, default: true }) readonly showCancel!: boolean;

  model = false;

  newCaseInput = {
    name: '',
    gender: '',
    birthday: '',
    phone: '',
    memo: ''
  };

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  closeDialog () {
    return false
  }

  @Emit('cancel')
  cancelDialog () {
    this.closeDialog()
  }

  @Watch('value')
  valueChanged () {
    this.model = this.value
  }

  @Emit('confirm')
  confirmDialog () {
    // do nothing
  }
}
